import {observe} from '@github-ui/selector-observer'
import {on} from 'delegated-events'
import {onFocus} from '@github-ui/onfocus'

function getMatchingPlaceholders(input: HTMLInputElement): NodeListOf<Element> {
  const fieldName = input.getAttribute('data-fieldname') || ''
  return document.querySelectorAll(`span[data-fieldname="${fieldName}"]`)
}

function getMatchingInput(placeholder: Element): HTMLInputElement {
  const fieldName = placeholder.getAttribute('data-fieldname') || ''
  return document.querySelector<HTMLInputElement>(`input[data-fieldname="${fieldName}"]`)!
}

function syncValue(input: HTMLInputElement, placeholders: NodeListOf<Element>) {
  if (input.value) {
    for (const el of placeholders) {
      el.textContent = input.value
    }
  }
}

onFocus('.js-template-form-input', function (input) {
  if (!(input instanceof HTMLInputElement)) return
  const placeholders = getMatchingPlaceholders(input)

  function inputHandler() {
    if (!(input instanceof HTMLInputElement)) return
    syncValue(input, placeholders)
  }

  // Highlight the placeholders.
  function highlight(isEnabled: boolean) {
    for (const el of placeholders) {
      el.classList.toggle('CommunityTemplate-highlight--focus', isEnabled)
    }
  }
  highlight(true)

  input.addEventListener('input', inputHandler)
  input.addEventListener('blur', function blurHandler() {
    highlight(false)
    input.removeEventListener('input', inputHandler)
    input.removeEventListener('blur', blurHandler)
  })
})

on('click', '.js-template-highlight', function (event) {
  getMatchingInput(event.currentTarget).focus()
})

observe('.js-templates', function () {
  // Looks for pre-filled forms and replaces content
  for (const input of document.querySelectorAll<HTMLInputElement>('.js-template-form-input')) {
    const placeholders = getMatchingPlaceholders(input)
    syncValue(input, placeholders)
  }
})
